import React, { memo } from "react";
import { Button, Spinner } from "reactstrap";

const LoadingButton = memo(({ children, isLoading, onClick, className, color = "primary", disabled }) => {
  return (
    <Button color={color} onClick={onClick} disabled={isLoading || disabled} className={`d-inline-flex align-items-center justify-content-center ${className || ""}`.trim()} style={{ gap: 8 }}>
      {isLoading && <Spinner size="sm" color="light" style={{ flexShrink: 0 }} />}
      <span>{children}</span>
    </Button>
  );
});

export default LoadingButton;
